<template>
    <div>
        <div class="modal hide fade" id="modalCustomerChangeName" tabindex="-1" role="dialog" aria-labelledby="modalCustomerChangeName" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Customer Change Name
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="name" class="col-sm-3 col-form-label text-left">Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="customer.name" class="form-control" disabled="disabled"/>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="email" class="col-sm-3 col-form-label text-left">New Name</label>
                                    <div class="col-sm-9">
                                        <input type="text" v-model="replace_name" class="form-control"/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-success" data-dismiss="modal" @click="save">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'CustomerChangeNameModal',
  props: ['customer'],
  data () {
    return {
      replace_name: null
    }
  },
  methods: {
    save () {
      var obj = {
        replace_name: this.replace_name
      }
      this.$emit('changeName', obj)
    }
  }
}
</script>
